import axios from "../../axiosInstance";

export const fetchShippingCompanies = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/shipping-company/get?perPage=${perPage}&page=${page}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
export const updateShippingCompanyStatus = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/shipping-company/update-status/${id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateShippingCompany = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/shipping-company/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
export const updateServiceStatusByAdmin = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/shipping-company/update-services/${id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchCustomCarriers = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/user-shipping-companies/get-admin-custom-account?perPage=${perPage}&page=${page}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addCustomCarrierAccount = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/user-shipping-companies/add-account`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateCustomCarrierStatus = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/user-shipping-companies/update-status/${id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const allowAdminAccount = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/user-shipping-companies/allow-admin-account`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateAllowedUserAccount = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/user-shipping-companies/update-allowed-user-account/${id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchAllowedAccounts = async (userId, page = 1, perPage = 20) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/user-shipping-companies/get-allowed-accounts/${userId}?page=${page}&perPage=${perPage}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateMainUserAccountCharge = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/user-shipping-companies/update-service-charge/${id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};